import React, { useEffect, useRef, useState } from 'react';
import { Container, Row, Col, Button, Form } from 'react-bootstrap';
import axiosInstance from "../../interceptor/axiosInstance";
import { useParams } from 'react-router-dom';
import { formatUpworkDate } from '../Utils/UtilityService';
import NotificationService from '../Utils/NotificationService.js';
import ReactQuill, { Quill } from "react-quill";
import "react-quill/dist/quill.snow.css";
import { FaDownload } from 'react-icons/fa'; // Import download icon
import FileUpload from '../Shared/FileUploader.js';
import config from '../../config.js';

// Function to capitalize first letter of each word (Camel Case)
const toCamelCase = (str) => {
  return str
    .split(' ')
    .map(word => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase())
    .join(' ');
};

const TicketPage = () => {
  const [ticket, setTicket] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');
  const [textEmpty, setTextEmpty] = useState('');
  const [message, setMessage] = useState('');
  const { encodeData } = useParams(); // Extract "encodeData" from the URL
  const [hoverIndex, setHoverIndex] = React.useState(null);
  const [hoverConvId, setHoverConvId] = React.useState(null);
  const [formData, setFormData] = useState({
    encodedText: '',
    message:'',
    attachments: [],
  });
  const fileInputRef = useRef(null);
  const removeHtmlTags = (str) => {
    return str.replace(/<[^>]*>/g, "");
  };
  const [files, setFiles] = useState([]);
  const [ws, setWs] = useState(null);
  const currentTicketRef = useRef(null);
  const conversationEndRef = useRef(null);
    
    // Update ref whenever selectedTicket changes
    useEffect(() => {
      currentTicketRef.current = ticket;
    }, [ticket]);

    useEffect(() => {
      if (conversationEndRef.current) {
        conversationEndRef.current.scrollTop = conversationEndRef.current.scrollHeight;
      }
    }, [ticket?.conversations]);
    
  const handleFileChange = (selectedFiles) => {
    console.log(selectedFiles); // Handle selected files
    setFormData({
      ...formData,
      attachments: Array.from(selectedFiles), // Update to handle multiple files
    });
    setFiles(selectedFiles);
  };
  const handleChange = (e) => {
    const { name, value, files } = e.target;
    if (name === "attachments") {
        setFormData({
          ...formData,
          attachments: Array.from(files), // Update to handle multiple files
        });
      } else {
        setFormData({ ...formData, [name]: value });
      }
  };

  // Fetch Ticket Details and Conversations from API
  const fetchTicketDetails = async () => {
    try {
      console.log("encodeData::", encodeData);
      const response = await axiosInstance.get(`/api/public/tickets?encodeData=${encodeData}`);
      console.log("Ticket details and conversations:", response.data);

      setTicket(response.data); // Assuming the response contains both ticket details and conversations
    } catch (error) {
      setError('Error fetching ticket details');
    }
  };

  useEffect(() => {
            const socket = new WebSocket(config.REACT_APP_WEBSOCKET_URL);
            setWs(socket);
    
            // Handle incoming messages
            socket.onmessage = async (event) => {
                if (event.data instanceof Blob) {
                   
                    let resData = JSON.parse(await event.data.text());
                    if(resData.type == 'ticket_message' && currentTicketRef.current.id == resData.ticketId){
                      fetchTicketDetails();
                      }
                } else {
                    // setMessages((prev) => [...prev, { type: 'received', text: event.data }]);
                }
            };
    
            // Cleanup on unmount
            return () => socket.close();
        }, []);

  // Fetch ticket details when component mounts or when `encodeData` changes
  useEffect(() => {
    if (encodeData) {
      setLoading(true); // Set loading to true when API call starts
      const fetchData = async () => {
        await fetchTicketDetails();
      };
      fetchData()
        .finally(() => {
          setLoading(false); // Set loading to false when the data has been fetched
        });
    }
  }, [encodeData]);

  // Handle sending the message
  const handleSendMessage = async () => {
    // const sanitizedMessage = message.trim() === "<p><br></p>" ? "" : message.trim();

  if (!removeHtmlTags(message)) {
      // setTextEmpty('Message is required');
      NotificationService.error('Message is required');
      return;
    }
    setTextEmpty('');
    try {
      // Add your logic to send a message (this can be an API call to save the message)
      const formDataToSubmit = new FormData();
        // Append the fields to FormData object
        for (let key in formData) {
          if (key === "attachments") {
            formData.attachments.forEach((file) => {
              formDataToSubmit.append("attachments", file);
            });
          } 
        }

    //   const payload = {
    //     encodedText: encodeData,
    //     message: message,
    //     ...attachments
    //   };
    formDataToSubmit.append("encodedText", encodeData);
    formDataToSubmit.append("message", message);
     const response = await axiosInstance.post(`/api/public/updateconversation`, formDataToSubmit, {
        headers: {
          "Content-Type": "multipart/form-data",  // Tell the server to expect multipart form data
        },
      });

      setMessage(''); // Clear the message input after sending
      if (fileInputRef.current) {
        fileInputRef.current.value = ''; // Reset the file input field
      }
      setFormData('');
      setFiles([]);
      fetchTicketDetails();
      NotificationService.success('Your reply has been successfully sent.');
      if (ws) {
        ws.send(JSON.stringify({ type: 'ticket_message', content: message, ticketId:ticket.id }));
      }

    } catch (error) {
      setError('Error sending message');
    }
  };

  const handleCloseTicket = async () => {
    try {
      // Add your logic to send a message (this can be an API call to save the message)
      const res = await axiosInstance.get(`/api/public/closeTicket?encodeData=${encodeData}`);
      if (ws) {
        if (ws) {
          ws.send(JSON.stringify({ type: 'ticket_message', ticketStatus:'close', content: '', ticketId:ticket.id }));
        }
      }
      fetchTicketDetails();
      NotificationService.success(res.data.message);
    } catch (error) {
      setError('Error sending message');
    }
  };

  const modules = {
    toolbar: [
      [{ header: [1, 2, false] }],
      ["bold", "italic", "underline"],
      [{ list: "ordered" }, { list: "bullet" }],
      ["link"],
    ],
  };

  const editorStyles = {
    // height: "200px",
    maxHeight: "200px", // Set the height for the content area
    overflow: "auto", // Enable vertical scrolling for content overflow
    borderRadius: "0 0 0 0", // Rounded corners for the bottom of the editor
    width: "100%",
    border: "1px solid #ddd", 
  };

  const handleDownload = async (fileUrl, fileName) => {
    try {
      if (!fileUrl) {
        throw new Error("Invalid file URL.");
      }
  
      // Fetch pre-signed URL from the backend
      const response = await axiosInstance.get("/tickets/generate-presigned-url", { params: { fileUrl } });
      const presignedUrl = response.data.presignedUrl;
  
      if (!presignedUrl) {
        throw new Error("Failed to generate pre-signed URL.");
      }
  
      // Force download using the pre-signed URL
      const link = document.createElement("a");
      link.href = presignedUrl;
      link.download = fileName || "download";
      link.target = "_blank";
  
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    } catch (error) {
      console.error("Error downloading file:", error);
      alert("Failed to download the file. Please try again.");
    }
  };
  

  if (loading) {
    return <div>Loading...</div>;
  }

  if (error) {
    return <div>{error}</div>;
  }

  return (
    <Container fluid style={styles.BackgroundWhite}>
      <div className="d-flex flex-column min-vh-86">
        <Row>
          {/* First 75% - Ticket Title and Conversations */}
          <Col md={9} 
            style={{ 
              paddingRight: '30px',
              maxHeight: 'calc(100vh - 200px)',
              overflowY: 'scroll', // or 'auto' if preferred
              flexGrow: 1,
              minHeight: 0,
              scrollbarWidth: 'none', // Firefox
              msOverflowStyle: 'none' // Internet Explorer 10+
              }}>
            {/* Ticket Title */}
            {ticket && (
              // <div style={{ paddingLeft: '25px' }}>
              //   <h2>{ticket.subject}</h2>
              // </div>
              <div
                style={{
                  paddingLeft: '25px',
                  position: 'sticky',
                  top: 0,
                  background: 'white',
                  zIndex: 10,
                  paddingTop: '15px',
                  paddingBottom: '10px',
                  borderBottom: '1px solid #ddd'
                }}
              >
                <h2 style={{ margin: 0 }}>{ticket.subject}</h2>
              </div>
            )}

            {/* Conversations */}
            <div 
              style={{
                padding: '2%',
                overflowY: 'auto',
                maxHeight: 'calc(100vh - 220px)', // adjust based on your layout
              }}
              ref={conversationEndRef}
            >
              {ticket && ticket.conversations && ticket.conversations.length > 0 ? (
                ticket.conversations.map((conversation, index) => {
                  const senderName = conversation.sender;
                  const initials = senderName ? senderName.charAt(0) + senderName.charAt(senderName.length - 1) : '';
                  const formattedName = toCamelCase(senderName); // Format the sender's name in camel case

                  return (
                    <div key={index} className="mb-3" style={{ display: 'flex' }}>
                      {/* Circle with initials (in uppercase) */}
                      <div
                        style={{
                          height: '40px',
                          borderRadius: '50%',
                          color: '#2a2727',
                          display: 'flex',
                          alignItems: 'center',
                          justifyContent: 'center',
                          fontSize: '15px',
                          padding: '10px',
                          border: '1px solid lightGrey'
                        }}
                      >
                        {initials.toUpperCase()} {/* Initials in uppercase */}
                      </div>
                      <div style={{ marginLeft: '10px' }}>
                        {formattedName} {/* Display name in camel case */}
                        <p className="text-muted" style={{ fontSize: '0.85em' }}>
                          {formatUpworkDate(conversation.conversation_created_at)}
                        </p>
                        <p dangerouslySetInnerHTML={{ __html: conversation.conversation_message }}></p>

                        {/* Attachments */}
                        {conversation.attachments && conversation.attachments.length > 0 && (
                          <div>
                            {conversation.attachments.map((attachment, attachmentIndex) => (
                              <div
                                key={attachmentIndex}
                                style={
                                  (hoverIndex === attachmentIndex && hoverConvId === conversation.conversation_id)
                                    ? { ...styles.attachmentContainer, ...styles.blackBorder }
                                    : { ...styles.attachmentContainer, ...styles.grayBorder }
                                }
                                onMouseEnter={() => {setHoverIndex(attachmentIndex); setHoverConvId(conversation.conversation_id);}}
                                onMouseLeave={() => {setHoverIndex(null); setHoverConvId(null);}}
                              >
                                {/* Left Block: File Name */}
                                <div style={styles.fileName}>{attachment.file_name}</div>
                                {/* Right Block: Download Icon */}
                                <div
                                  style={
                                    (hoverIndex === attachmentIndex && hoverConvId === conversation.conversation_id)
                                      ? { ...styles.downloadIcon, ...styles.downloadIconVisible }
                                      : styles.downloadIcon
                                  }
                                >
                                  <a
                                    href="#"
                                    onClick={(e) => {
                                      e.preventDefault();
                                      handleDownload(attachment.file_url, attachment.file_name);
                                    }}
                                    download
                                  >
                                    <FaDownload style={styles.iconStyle} />
                                  </a>
                                </div>
                              </div>
                            ))}
                          </div>
                        )}
                      </div>
                    </div>
                  );
                })
              ) : (
                <p>No conversations available.</p>
              )}
            </div>
          </Col>

          {/* Second 27% - Ticket Details */}
          <Col md={3} className="d-flex flex-column" style={{ paddingRight: '30px' }}>
            {ticket && (
              <div className="mb-3">
                <div className="d-flex flex-column" style={styles.Margin_90}>
                  <div style={styles.detailsBox}>
                    <table>
                      <tbody>
                        <tr style={styles.detailsItem}>
                          <td style={{ width: '120px' }}><strong>Ticket ID </strong></td>
                          <td>#{ticket.ticket_no}</td>
                        </tr>
                        <tr style={styles.detailsItem}>
                          <td style={{ width: '120px' }}><strong>Status </strong></td>
                          <td><span style={styles.capsuleStyle}>{ticket.status}</span></td>
                        </tr>
                        <tr style={styles.detailsItem}>
                          <td style={{ width: '120px' }}><strong>Created At </strong></td>
                          <td>{formatUpworkDate(ticket.created_at)}</td>
                        </tr>
                        <tr style={styles.detailsItem}>
                          <td style={{ width: '120px' }}><strong>Last Active </strong></td>
                          <td>{formatUpworkDate(ticket.updated_at)}</td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>
            )}
          </Col>
        </Row>

        {/* Message Editor */}
        {ticket.status !== "Closed" && (
          <Row>
            <Col md={9}>
            <div style={{ display: 'flex', alignItems: 'center', width: "93.5%" }}><FileUpload handleChange={handleFileChange} files={files}/></div>
            <div style={{ display: "flex", alignItems: "center", justifyContent: "space-between" }} className='mb-4'>
                         
              <ReactQuill
                modules={modules}
                theme="snow"
                value={message}
                onChange={(content) => setMessage(content)}
                placeholder="Type a message..."
                style={editorStyles} // Apply custom styles to the content area
              />
              {/* <Form.Group className="mb-3">
              <Form.Control
                type="file"
                name="attachments"
                multiple // Allow multiple file selection
                onChange={handleChange}
                ref={fileInputRef} 
                className="rounded-pill"
              />
            </Form.Group> */}
              <Button
                variant="primary mx-2"
                onClick={handleSendMessage}
                style={{ marginTop: '10px' }}
              >
                Send
              </Button>
              </div>
            </Col>
          </Row>
        )}
        
      </div>
      {ticket.status !== "Closed" && (
        <div style={{ position: "fixed", bottom: "60px", right: "60px" }}>
          <Button
            variant="secondary"
            onClick={handleCloseTicket}
          >
            Close Ticket
          </Button>
        </div>
      )}
    </Container>
  );
};

const styles = {
  detailsBox: {
    padding: '20px',
    marginBottom: '20px',
    border: '3px solid #ddd',
    borderRadius: '5px',
    backgroundColor: 'transparent',
  },
  detailsItem: {
    marginBottom: '10px',
    fontSize: '0.9em',
  },
  BackgroundWhite: {
    backgroundColor: "white",
  },
  Margin_90: {
    marginTop: "90px",
  },
  capsuleStyle: {
    display: 'inline-block',
    padding: '5px 15px',
    fontSize: '14px',
    fontWeight: '500',
    color: 'white',
    backgroundColor: 'blue',
    borderRadius: '50px',
    textAlign: 'center',
    whiteSpace: 'nowrap',
    boxShadow: '0 2px 4px rgba(0, 0, 0, 0.1)',
    transition: 'background-color 0.3s ease, transform 0.2s ease',
    // cursor: 'pointer', // Optional
  },
  attachmentContainer: {
    position: 'relative',
    display: 'inline-block',
    marginBottom: '10px',
    width: '200px',
    height: '50px',
    // backgroundColor: '#f0f0f0',
    // borderRadius: '8px',
    overflow: 'hidden',
    textAlign: 'center',
    marginRight: '15px',
    paddingTop: '10px',
    border: '2px solid #d3d3d3'
  },
  grayBorder: {
    border: '2px solid #d3d3d3',
  },
  blackBorder: {
    border: '2px solid black',
  },
  attachmentBox: {
    padding: '5px',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap',
    fontSize: '12px',
  },
  downloadIcon: {
    top: '20%',
    display: "none", // Initially hide the download icon
    position: "absolute",
    right: "10px",
    transform: "translateY(-50%)",
    cursor: "pointer",
  },
  iconStyle: {
    color: 'gray',
  },

  fileName: {
    flex: 1, // Allow the name block to take up available space
    textAlign: "left", // Align text to the left
    overflow: "hidden", // Handle overflow
    textOverflow: "ellipsis", // Ellipsis for long names
    whiteSpace: "nowrap", // Prevent wrapping
    padding: "5px",
  },
  downloadIconVisible: {
    display: "block", // Show the download icon on hover
  },
};

export default TicketPage;